
import React, { useState, useEffect, useRef } from 'react';
import HeaderSearchBar from "../../../../../Components/UiComponents/HeaderSearchBar";
import DataTable from '../../../../../Components/UiComponents/DataTable';
import ButtonElement from "../../../../../Components/UiComponents/ButtonElement";
import ToastElement from "../../../../../Components/UiComponents/ToastElement";
import { Dialog } from "primereact/dialog";
// Services
import { getField } from '../../../../../Services/tooltipService';
import { getAddressList, getContactList, deleteAddressFromPages, deleteContactFromPages } from '../../../../../Services/addressService';
import { exportClientContact, get } from '../../../../../Services/clientService';
import CreateNewAddress from './createNewAddress';
import CreateNewContacts from './createNewContacts';
import EditContact from './editContact';
import EditAddress from './editAddress';
import { InputIcon } from "primereact/inputicon";
import _ from 'lodash';
import { downloadDocs, getAssociatedProj } from '../../../../../Services/opportunityService';
import { Link } from 'react-router-dom';
import Loader from '../../../../../Components/UiComponents/Loader';
import PlaylistVideos from '../../../../../Components/Videos/PlaylistVideos';
const Address = (props) => {
    const [loading, setLoading] = useState(false)
    const [addressDetails, setAddressDetails] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchContactQuery, setSearchContactQuery] = useState("");
    const [searchedLength, setSearchedLength] = useState(0);
    const [searchedContactLength, setSearchedContactLength] = useState(0);
    const [contactDetails, setContactDetails] = useState([]);
    const [filterAddressDetails, setFilterAddressDetails] = useState([]);
    const [filterContactDetails, setFilterConactDetails] = useState([]);
    const [position, setPosition] = useState("center");
    const [visible, setVisible] = useState(false);
    const [contactPosition, setContactPosition] = useState("center");
    const [contactVisible, setContactVisible] = useState(false);
    const [fieldDetails, setFieldDetails] = useState([]);
    const [clientName, setClientName] = useState("");
    const [ids, setIds] = useState([]);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteContactDialog, setDeleteContactDialog] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [visibleAddressEdit, setVisibleAddressEdit] = useState(false);
    const [contactDetail, setContactDetail] = useState([]);
    const [addressDetail, setAddressDetail] = useState([]);
    const [updatedAddress, setUpdatedAddress] = useState([]);
    const [idsContact, setIdsContact] = useState([]);
    const [updatedContact, setUpdatedContact] = useState([]);
    const [projectsAssociated, setProjectsAssociated] = useState([]);
    const [projAssoDialog, setProjAssoDialog] = useState(false);
    const [isAssoiciated, setIsAssoiciated] = useState(false);
    const [showVideo, setShowVideo] = useState(false);

    const toastRef = useRef();

    useEffect(() => {
        getCustomerField();
        getAddressDetails();
        getContactDetails();

    }, [props?.customerId, props?.clientName]);
    useEffect(() => {
        if (props.branch) {
            cliData();
        }
    }, [props.clientId, props.branch])

    const cliData = async () => {
        setLoading(true); 
        try {
          // Check if required props are available
          if (props.clientId && props.customerId && props.branch) {
            const res = await get(props.clientId, props.customerId, props.branch);
      
            // Ensure that the response contains data and client info
            if (res && res.data && res.data.client && res.data.client.length > 0) {
              const cliData = res.data.client[0];
              setClientName(cliData?.client_name);
            } else {
              toastRef.current.showToast({
                type: "error",
                message: "Client data not found. Please check the provided details.",
              });
            }
          }
        } catch (error) {
          // Handle errors during the API request
          toastRef.current.showToast({
            type: "error",
            message: "Failed to fetch client data. Please try again or contact Admin."
          });
        } finally {
          setLoading(false);
        }
      };
      
      

    const getCustomerField = async function () {
        setLoading(true); 
    
        try {
            if (props?.customerId !== null) {
                const customerData = await getField(props?.customerId);
    
                // Check if the response has data before accessing it
                if (customerData && customerData?.data?.cust && customerData.data.cust.length > 0) {
                    setFieldDetails(customerData.data.cust[0].modules);
                } else {
                    toastRef.current.showToast({
                        type: "warning",
                        message: "No customer data found.",
                    });
                }
            } 
        } catch (error) {
            // Handle errors during the API request
            toastRef.current.showToast({
                type: "error",
                message: "Failed to fetch customer field details. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false); 
        }
    };
    
    const getAddressDetails = async function () {
        setLoading(true); 
        try {
            if (props?.customerId && props?.clientId) {
                let data = {
                    limit: 10,
                    skip: 0,
                    searchByAddress: ''
                };
    
                // Fetch address list
                const customerData = await getAddressList(props.clientId, props.customerId, data.skip, data.limit, data.searchByAddress);
    
                // Check if the response contains address data
                if (customerData && customerData?.data?.address) {
                    setAddressDetails(customerData.data.address);
                    setFilterAddressDetails(customerData.data.address);
                } else {
                    toastRef.current.showToast({
                        type: "error",
                        message: "No address details found."
                    });
                }
            }
        } catch (error) {
            // Handle errors during the API request
            toastRef.current.showToast({
                type: "error",
                message: "Failed to fetch address details. Please try again or contact Admin."
            });
        } finally {
            setLoading(false); 
        }
    };
    
    const getContactDetails = async function () {
        setLoading(true); 
        try {
            if (props?.customerId && props?.clientId) {
                let data = {
                    skip: 0,
                    searchByContact: ''
                };
                
                // Call API to get the contact list
                const customerData = await getContactList(
                    props.clientId,
                    props.customerId,
                    data.skip,
                    data.limit,
                    data.searchByContact
                );
    
                // Check if the API response is valid
                if (customerData && customerData.data) {
                    setContactDetails(customerData.data.contact);
                    setFilterConactDetails(customerData.data.contact);
                } else {
                    // Handle unexpected response structure
                    toastRef.current.showToast({
                        type: "error",
                        message: "No contact details found. Please try again."
                    });
                }
            }
        } catch (error) {
            // Handle any errors during the API request
            toastRef.current.showToast({
                type: "error",
                message: "Failed to fetch contact details. Please try again or contact Admin."
            });
        } finally {
            setLoading(false);
        }
    };
    

    const checkingDisplayName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.address_name != null && rowData.address_name !== "") {
            return <div>{rowData.address_name}</div>;
        }
    };
    const checkingAddressName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.building_name != null && rowData.building_name !== "") {
            return <div>{rowData.building_name}</div>;
        }
    };
    const checkingAddressName1 = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.address_line_two != null && rowData.address_line_two !== "") {
            return <div>{rowData.address_line_two}</div>;
        }
    };
    const checkingOfficeNumber = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.office_addr_contact != null && rowData.office_addr_contact !== "") {
            return <div>{rowData.office_addr_contact}</div>;
        }
    };
    const checkingTelephone = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.telephone_number != null && rowData.telephone_number !== "") {
            return <div>{rowData.telephone_number}</div>;
        }
    };
    const checkingCityName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.city != null && rowData.city !== "") {
            return <div>{rowData.city}</div>;
        }
    };
    const checkingStateName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.state != null && rowData.state !== "") {
            return <div>{rowData.state}</div>;
        }
    };
    const checkingCountryName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.country != null && rowData.country !== "") {
            return <div>{rowData.country}</div>;
        }
    };
    const checkingpostcode = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.postcode != null && rowData.postcode !== "") {
            return <div>{rowData.postcode}</div>;
        }
    };

    const locationTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Location Name" })?.display_name
    }

    const addressTemplate1 = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Address Line 1" })?.display_name
    }

    const addressTemplate2 = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Address Line 2" })?.display_name
    }

    const officeTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Office Number" })?.display_name
    }

    const phoneTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Telephone Number" })?.display_name
    }

    const cityTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "City" })?.display_name
    }

    const stateTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "State/County" })?.display_name
    }

    const codeTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Postcode" })?.display_name
    }

    const countryTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Country" })?.display_name
    }

    const columns = [
        // Column configuration for the "Question" field
        {
            field: "Location Name", // Data field to map from the row data
            header: locationTemplate, // Header label for the column
            body: checkingDisplayName, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Address Line 1", // Data field to map from the row data
            header: addressTemplate1, // Header label for the column
            body: checkingAddressName, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Address Line 2", // Data field to map from the row data
            header: addressTemplate2, // Header label for the column
            body: checkingAddressName1, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Office Number", // Data field to map from the row data
            header: officeTemplate, // Header label for the column
            body: checkingOfficeNumber, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Telephone Number", // Data field to map from the row data
            header: phoneTemplate, // Header label for the column
            body: checkingTelephone, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "City", // Data field to map from the row data
            header: cityTemplate, // Header label for the column
            body: checkingCityName, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "State/County", // Data field to map from the row data
            header: stateTemplate, // Header label for the column
            body: checkingStateName, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Postcode", // Data field to map from the row data
            header: codeTemplate, // Header label for the column
            body: checkingpostcode, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Country", // Data field to map from the row data
            header: countryTemplate, // Header label for the column
            body: checkingCountryName, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        }
    ]

    const checkingName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.full_name != null && rowData.full_name !== "") {
            return <div onClick={() => rowClick(rowData)} >{rowData.full_name}</div>;
        }
    };
    const checkingRole = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.role != null && rowData.role !== "") {
            return <div>{rowData.role}</div>;
        }

    };
    const checkingMobile = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.team_member_contact != null && rowData.team_member_contact !== "") {
            return <div>{rowData.team_member_contact}</div>;
        }
    };
    const checkingLocation = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.address_name != null && rowData.address_name !== "") {
            return <div>{rowData.address_name}</div>;
        }
    };
    const checkingEmail = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.email != null && rowData.email !== "") {
            return <div>{rowData.email}</div>;
        }
    };

    const handleCheck = async (id) => {
        setLoading(true); 
        try {
            const projAssociation = await getAssociatedProj(props?.customerId, props?.clientId, id);
    
            // Check if the response is successful
            if (projAssociation && projAssociation.data.success) {
                if (projAssociation.data.result.length > 0) {
                    setProjectsAssociated(projAssociation.data.result);
                    setProjAssoDialog(true);
                } else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: 'Contact not associated with any project',
                    });
                }
            } else {
                // Handle unexpected success response but no result
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Failed to retrieve project association. Please try again.',
                });
            }
        } catch (error) {
            // Handle any errors that occur during the API call
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred while fetching project associations. Please try again or contact Admin.',
            });
        } finally {
            setLoading(false); 
        }
    };
    

    const checkingAssociation = (rowData) => {
        // Check if display name exists and is not empty
        // if (rowData?.associated != null && rowData.associated !== "") {
        //     return <div>{rowData.associated}</div>;
        // }
        return (

            <div>
                <InputIcon
                    className={"pi pi-book"
                    }
                    style={{ color: 'blue' }}
                    onClick={() => handleCheck(rowData._id)}
                />
            </div>
        );
    };
    const checkingBusiness = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData?.business_unit != null && rowData.business_unit !== "") {
            return <div>{rowData.business_unit}</div>;
        }
    };
    const checkingOrdinate = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData?.owner != null && rowData?.owner !== "") {
            return <div>{rowData.owner}</div>;
        }
    };
    const checkingwebsite = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.website != null && rowData.website !== "") {
            const truncatedComment = rowData.website.length > 7 ? rowData.website.substring(0, 7) + "..." : rowData.website;
            return <Link to={`${rowData.website}`} >{truncatedComment}</Link>
        }
    };
    const checkingComments = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.comment != null && rowData.comment !== "") {
            const truncatedComment = rowData.comment.length > 7 ? rowData.comment.substring(0, 7) + "..." : rowData.comment;
            return <div>{truncatedComment}</div>;
        }
    };
    const checkingStatus = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData?.status != null && rowData?.status !== "") {
            return <div>{rowData.status}</div>;
        }
    };

    const nameTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Name" })?.display_name
    }

    const roleTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Role" })?.display_name
    }

    const mobileTemplate = () => {
        return _.find(props.AddressContactData.addressContactFields, { field_name: "Mobile Number" })?.display_name
    }

    const emailTemplate = () => {
        return _.find(props.AddressContactData.addressContactFields, { field_name: "Email" })?.display_name
    }

    const projectTemplate = () => {
        return _.find(props.AddressContactData.addressContactFields, { field_name: "Project Association" })?.display_name
    }

    const buTemplate = () => {
        return _.find(props.AddressContactData.commonFields, { field_name: "Business Unit" })?.display_name
    }

    const coordinatorTemplate = () => {
        return _.find(props.AddressContactData.addressContactFields, { field_name: "Co-ordinator" })?.display_name
    }

    const websiteTemplate = () => {
        return _.find(props.AddressContactData.addressContactFields, { field_name: "Website" })?.display_name
    }

    const commentsTemplate = () => {
        return _.find(props.AddressContactData.addressContactFields, { field_name: "Comments" })?.display_name
    }

    const statusTemplate = () => {
        return _.find(props.AddressContactData.addressContactFields, { field_name: "Status" })?.display_name
    }

    const column = [
        // Column configuration for the "Question" field
        {
            field: nameTemplate, // Data field to map from the row data
            header: nameTemplate, // Header label for the column
            body: checkingName, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Role", // Data field to map from the row data
            header: roleTemplate, // Header label for the column
            body: checkingRole, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Mobile Number", // Data field to map from the row data
            header: mobileTemplate, // Header label for the column
            body: checkingMobile, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Email", // Data field to map from the row data
            header: emailTemplate, // Header label for the column
            body: checkingEmail, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Project Association", // Data field to map from the row data
            header: projectTemplate, // Header label for the column
            body: checkingAssociation, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Location Name", // Data field to map from the row data
            header: locationTemplate, // Header label for the column
            body: checkingLocation, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Business Unit", // Data field to map from the row data
            header: buTemplate, // Header label for the column
            body: checkingBusiness, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Co-ordinator", // Data field to map from the row data
            header: coordinatorTemplate, // Header label for the column
            body: checkingOrdinate, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Website", // Data field to map from the row data
            header: websiteTemplate, // Header label for the column
            body: checkingwebsite, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Comments", // Data field to map from the row data
            header: commentsTemplate, // Header label for the column
            body: checkingComments, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        },
        {
            field: "Status", // Data field to map from the row data
            header: statusTemplate, // Header label for the column
            body: checkingStatus, // Custom renderer for the cell content
            headerClassName: "header-datatable white-space",
            className: 'row-datatable'
        }
    ]

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        filteredQuestionsArray(e.target.value);
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        filteredQuestionsArray("");
        getAddressDetails();
    };

    const handleSearchContactChange = (e) => {
        setSearchContactQuery(e.target.value);
        filteredArray(e.target.value);
    };

    const handleClearContactFilter = () => {
        setSearchContactQuery("");
        filteredArray("");
        getContactDetails();
    };


    const filteredQuestionsArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            getAddressDetails();
            setSearchedLength(lowerCaseQuery.length); // Update the searched length after resetting the data


        } else {
            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }

            // Filter the customer reference data if the query is not empty
            const filteredData = filterAddressDetails.filter(item => {
                // Check if any value in the item includes the query string
                return Object.values(item).some(value => {
                    // Convert value to string and to lowercase for comparison
                    return value.toString().toLowerCase().includes(lowerCaseQuery);
                });
            });

            // Update the state with the filtered data
            setAddressDetails(filteredData);

        }
    }

    const filteredArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            getContactDetails();
            setSearchedContactLength(lowerCaseQuery.length); // Update the searched length after resetting the data


        } else {
            if (lowerCaseQuery.length > searchedContactLength) {
                setSearchedContactLength(lowerCaseQuery.length);
            } else {
                setSearchedContactLength(lowerCaseQuery.length);
            }

            // Filter the customer reference data if the query is not empty
            const filteredData = filterContactDetails.filter(item => {
                // Check if any value in the item includes the query string
                return Object.values(item).some(value => {
                    // Convert value to string and to lowercase for comparison
                    return value.toString().toLowerCase().includes(lowerCaseQuery);
                });
            });

            // Update the state with the filtered data
            setContactDetails(filteredData);

        }
    }

    const show = (position) => {
        setPosition(position);
        setVisible(true);
    };
    const handleHide = () => {
        setVisible(false);
        getAddressDetails();
        setVisibleAddressEdit(false);
    };
    const handleContactHide = () => {
        setContactVisible(false);
        getContactDetails();
        setVisibleEdit(false);
    };
    const showContact = (position) => {
        setContactPosition(position);
        setContactVisible(true);
    };
    const Export = async () => {
        try {
            setLoading(true); // Start loading spinner
            
            // Call the API to export client contacts
            exportClientContact(props?.clientId, props?.customerId);
            
            // Check if the response is valid
            // if (response && response.data) {
            //     downloadDocs(response.data.fileName, token); 
            // } else {
            //     // If no data is returned, show an error
            //     toastRef.current.showToast({
            //         type: 'error',
            //         message: 'No data returned from the export.'
            //     });
            // }
        } catch (error) {
            // Handle errors during the API request
            toastRef.current.showToast({
                type: 'error',
                message: 'Failed to export client contacts. Please try again or contact Admin.'
            });
        } finally {
            setLoading(false); 
        }
    };
    

    const removeField = async (selectedIndex, data) => {
        const ids = [];

        data.forEach(item => {
            ids.push(item._id);
        });
        setIds(ids)
        setUpdatedAddress(data);
    };

    const removeFieldContact = async (selectedIndex, data) => {
        const ids = [];

        data.forEach(item => {
            ids.push(item._id);
        });
        setIdsContact(ids)
        setUpdatedContact(data);
    };

    const deleteField = async () => {
        setLoading(true); 
        try {
            const deleteResponse = await deleteAddressFromPages(ids[0]);
    
            // Check if the response is successful
            if (deleteResponse && deleteResponse?.status === 200) {
                setUpdatedAddress([]);
                toastRef.current.showToast({
                    type: 'success',
                    message: 'Deleted Successfully',
                });
            } else {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Error: failed to delete',
                });
            }
    
            getAddressDetails();
        } catch (error) {
            // Handle any errors that occur during the delete process
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred while deleting. Please try again or contact Admin.',
            });
        } finally {
            hideDeleteProductDialog();
            setLoading(false);
        }
    };
    

    const deleteContact = async () => {
        try {
          setLoading(true); 
      
          // Attempt to delete the contact
          const deleteResponse = await deleteContactFromPages(idsContact[0]);
      
          // Check response and show appropriate toast notification
          if (deleteResponse && deleteResponse?.status === 200) {
            setUpdatedContact([]);
            toastRef.current.showToast({
              type: 'success',
              message: `Deleted Successfully`,
            });
          } else {
            toastRef.current.showToast({
              type: 'error',
              message: `Error: failed to delete`,
            });
          }
      
          // Execute any follow-up actions
          hideDeleteContactDialog();
          getContactDetails();
          
        } catch (error) {
          // Handle errors during the API request
          toastRef.current.showToast({
            type: 'error',
            message: 'Error deleting contact. Please try again or contact Admin.',
          });
        } finally {
          setLoading(false); 
        }
      };
      

    const confirmDeleteContact = () => {
        setDeleteContactDialog(true)
    }
    const confirmDeleteProduct = () => {
        var clientAddressData = addressDetails.filter(
            (item) => updatedAddress.some((selected) => selected._id === item._id)
        );

        var cliAddContact = contactDetails.filter(
            (item) => clientAddressData.some((selected) => selected.address_name === item.address_name)
        );

        if (cliAddContact.length > 0) {
            setIsAssoiciated(true);
        } else {
            setIsAssoiciated(false);
        }

        setDeleteProductDialog(true);
    };
    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    };
    const hideDeleteContactDialog = () => {
        setDeleteContactDialog(false);
    };
    const deleteProductDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteProductDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} />
                </div>
            </div>
        );
    }

    const deleteContactDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteContactDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteContact} />
                </div>
            </div>
        );
    }

    const projAssoDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Close" className="cancel-new-button" onClick={hideProjAssoDialogDialog} />
                </div>
            </div>
        );
    }

    const hideProjAssoDialogDialog = () => {
        setProjAssoDialog(false)
    }

    const showEdit = (position) => {
        setPosition(position);
        setVisibleEdit(true);
    };
    const showAddressEdit = () => {
        setPosition(position);
        setVisibleAddressEdit(true);
    }

    const rowClick = async (data) => {
        if (data?.first_name) {
            setContactDetail(data)
            showEdit();
        }
        else if (data?.address_name) {
            setAddressDetail(data)
            showAddressEdit();
        }
    };

    const rowClickContacts = (data) => {
        showEdit();
    }

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div className="mt-10">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="col-md-12 text-right">
				<ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
			</div>

            <div className="header-design">
                <div>
                    <p className="fs-16 fw-600 mar-b-3">{_.find(props?.AddressContactData?.clientSectionsSummary, { section_name: "Address" })?.display_name}</p>
                </div>
                {/* <ButtonElement
                    className="upload-button"
                    type="button"
                    icon="pi pi-question"
                /> */}
            </div>
            <div className="group-table-buttons">
                <div className="delete-button">
                    {
                        updatedAddress.length > 0 && <ButtonElement
                            className="delete-button-icon"
                            type="button"
                            icon="pi pi-trash"
                            onClick={() => confirmDeleteProduct()}
                        />
                    }
                </div>
                <div className="group-table-search">
                    <HeaderSearchBar
                        value={searchQuery}
                        onChange={(e) => handleSearchChange(e)}
                        onClick={handleClearFilter}
                    />
                    <ButtonElement
                        className="edit-option-button ml-10"
                        type="button"
                        icon="pi pi-plus"
                        onClick={() => show("right")}
                    />
                </div>
            </div>

            <DataTable
                value={addressDetails}
                columns={columns}
                searchQuery={searchQuery}
                removeField={removeField}
                rowClick={rowClick}
                dataKey="_id"
                isNotReorder={true}
            />

            <div className="group-table-component">
                <div className="header-design">
                    <div>
                        <p className="fs-16 fw-600 mar-b-3">{_.find(props.AddressContactData.clientSectionsSummary, { section_name: "Contact" })?.display_name}</p>
                    </div>
                </div>
                <div className="group-table-buttons">
                    <div className="delete-button">
                        {
                            updatedContact.length > 0 &&
                            <ButtonElement
                                className="delete-button-icon"
                                type="button"
                                icon="pi pi-trash"
                                onClick={() => confirmDeleteContact()}
                            />
                        }
                    </div>
                    <div className="group-table-search">
                        <HeaderSearchBar
                            value={searchContactQuery}
                            onChange={(e) => handleSearchContactChange(e)}
                            onClick={handleClearContactFilter}
                        />
                        <ButtonElement
                            className="edit-option-button ml-10"
                            type="button"
                            icon="pi pi-plus"
                            onClick={() => showContact("right")}
                        />
                    </div>
                </div>

                <DataTable
                    value={contactDetails}
                    columns={column}
                    searchQuery={searchContactQuery}
                    removeField={removeFieldContact}
                    dataKey="_id"
                    isNotReorder={true}
                // rowClick={rowClick}
                />
            </div>

            <div className="cancel-footer mt-20">
                <div className='d-flex align-center justify-end pb-0'>
                    <ButtonElement type="submit" label="Export" className="save-button" onClick={() => { Export() }} disabled={!contactDetails || contactDetails.length === 0}/>
                </div>
            </div>
            <CreateNewAddress
                visible={visible}
                position={position}
                customerId={props?.customerId}
                fieldDetail={fieldDetails}
                clientName={clientName}
                onHide={handleHide}
                clientId={props?.clientId}
                clientSectionsSummary={props.AddressContactData.clientSectionsSummary}
                commonFields={props.AddressContactData.commonFields}
            />
            <CreateNewContacts
                visible={contactVisible}
                position={contactPosition}
                customerId={props?.customerId}
                clientName={clientName}
                fieldDetail={fieldDetails}
                onHide={handleContactHide}
                clientId={props?.clientId}
                fieldDetails={fieldDetails}
                addressDetails={addressDetails}
                clientSectionsSummary={props.AddressContactData.clientSectionsSummary}
                commonFields={props.AddressContactData.commonFields}
                addressContactFields={props.AddressContactData.addressContactFields}
            />
            <EditContact
                visible={visibleEdit}
                position={'right'}
                customerId={props?.customerId}
                clientName={clientName}
                contactDetail={contactDetail}
                fieldDetail={fieldDetails}
                onHide={handleContactHide}
                clientId={props?.clientId}
                fieldDetails={fieldDetails}
                addressDetails={addressDetails}
                clientSectionsSummary={props.AddressContactData.clientSectionsSummary}
                commonFields={props.AddressContactData.commonFields}
                addressContactFields={props.AddressContactData.addressContactFields}
            />
            <EditAddress
                visible={visibleAddressEdit}
                position={'right'}
                customerId={props?.customerId}
                clientName={clientName}
                addressDetail={addressDetail}
                fieldDetail={fieldDetails}
                onHide={handleHide}
                clientId={props?.clientId}
                clientSectionsSummary={props.AddressContactData.clientSectionsSummary}
                commonFields={props.AddressContactData.commonFields}
            />

            <Dialog visible={deleteProductDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={_.find(props.AddressContactData.clientSectionsSummary, { section_name: "Delete Client's Address" })?.display_name} modal footer={deleteProductDialogFooter()} onHide={hideDeleteProductDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    {
                        isAssoiciated &&
                        <span className="table-description">
                            {updatedAddress.length > 1 ? (
                                <span className="table-description">
                                    {updatedAddress.map((item, index) => (
                                        <b key={index}>{item.address_name}{index < updatedAddress.length - 1 ? ', ' : ''}</b>
                                    ))} {' '} is associated with few client contacts. Are you sure to delete?
                                    ?
                                </span>
                            ) : (
                                <span className="table-description">
                                    <b>{updatedAddress[0]?.address_name}</b> {' '} is associated with few client contacts. Are you sure to delete?
                                </span>
                            )}
                        </span>
                    }
                    {
                        !isAssoiciated &&
                        <span className="table-description">
                            {updatedAddress.length > 1 ? (
                                <span className="table-description">
                                    Are you sure to delete {' '}
                                    {updatedAddress.map((item, index) => (
                                        <b key={index}>{item.address_name}{index < updatedAddress.length - 1 ? ', ' : ''}</b>
                                    ))} from client address ?
                                    ?
                                </span>
                            ) : (
                                <span className="table-description">
                                    Are you sure to delete {' '} <b>{updatedAddress[0]?.address_name}</b> from client address ?
                                </span>
                            )}
                        </span>
                    }
                </div>
            </Dialog>

            <Dialog visible={deleteContactDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteContactDialogFooter()} onHide={hideDeleteContactDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    <span className="table-description">
                        {contactDetails.length > 1 ? (
                            <span className="table-description">
                                Are you sure to delete {' '}
                                {contactDetails.map((item, index) => (
                                    <b key={index}>{item.full_name}{index < contactDetails.length - 1 ? ', ' : ''}</b>
                                ))} from client team ?
                                ?
                            </span>
                        ) : (
                            <span className="table-description">
                                Are you sure to delete {' '} <b>{contactDetails[0]?.full_name}</b> from client team ?
                            </span>
                        )}
                    </span>
                </div>
            </Dialog>

            <Dialog visible={projAssoDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={projAssoDialogFooter()} onHide={hideProjAssoDialogDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    <span className="table-description">
                        {
                            projectsAssociated.length > 0 && projectsAssociated.map(pro => (
                                <li>
                                    <a className="form-label-text text-left mr-20 pointer">{pro.opportunity_name}</a>
                                </li>
                            ))
                        }
                    </span>
                </div>
            </Dialog>

            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_STAKEHOLDERS_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="stakeholders_address" />
                    </div>
                </div>
            </Dialog>

        </div>
    );
};

export default Address;
